import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({ texte }: { texte: string }) {
  return (
    <div className="md">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{texte}</ReactMarkdown>
    </div>
  );
}
